import { actions } from '../actions';

const defaultState = {
    loading: false,
    lastErrorMessage: '',
    formErrors: null,
    fullscreenLogMessage: '',
    mediaBrowserData: null,
    appConfig: null,
};

const commons = (state = defaultState, action) => {

    switch (action.type) {

        case actions.SET_LOADING:
            return Object.assign({}, state, { loading: action.value });

        case actions.SET_LAST_ERROR_MESSAGE:
            return Object.assign({}, state, { lastErrorMessage: action.value });

        case actions.SET_FORM_ERRORS:
            return Object.assign({}, state, { formErrors: action.value });

        case actions.SET_FULLSCREEN_LOG_MESSAGE:
            return Object.assign({}, state, { fullscreenLogMessage: action.value });

        case actions.SET_MEDIA_BROWSER_DATA:
            return Object.assign({}, state, { mediaBrowserData: action.value });

        case actions.SET_APP_CONFIG:
            return Object.assign({}, state, { appConfig: action.value });

        default:
            return state;

    }

};

export default commons;
